export const firebaseConfig = {
    apiKey: "AIzaSyD2HP5ET8RWJqa0k2TCuXOy1chhqddAFzw",
    authDomain: "visionwear-b8a36.firebaseapp.com",
    databaseURL: "https://jonaspaul-backport.firebaseio.com",
    projectId: "visionwear-b8a36",
    storageBucket: "jonaspaul-backport",
    messagingSenderId: "170580892324",
    appId: "1:170580892324:web:42c1abfd71e491475e6431",
    measurementId: "G-YKL5PNSD14"
}

export const useCodeStore = false